import { render } from "./IconFolderRounded.vue?vue&type=template&id=8cb9e780"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFolderRounded.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8cb9e780"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8cb9e780', __exports__)) {
    api.reload('8cb9e780', __exports__)
  }
  
  module.hot.accept("./IconFolderRounded.vue?vue&type=template&id=8cb9e780", () => {
    api.rerender('8cb9e780', render)
  })

}


export default __exports__